import React, { useState } from "react";
import { Layout, Menu } from "antd";
import {
  UsergroupAddOutlined,
  LinkOutlined,
  MacCommandOutlined,
  ShoppingOutlined,
  AlertOutlined,
  ToolOutlined,
  ApartmentOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import styles from "./sidebar.module.scss";
import logo from "../../assets/images/radarlogo.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = () => {
  const location = useLocation(); // Get the current location
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Sider
      theme={"light"}
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapse}
      width={collapsed ? 80 : 230}
    >
      <div className={styles.logoContainer}>
        <img
          src={logo}
          alt="Logo"
          className={styles.logo}
          style={{ height: collapsed ? "10px" : "24px", filter: 'invert(1)' }}
          onClick={() => navigate("/")}
        />
      </div>
      <Menu
        selectedKeys={[location.pathname]} // Set the selected key based on the current path
        defaultOpenKeys={["command_sub_system"]} // command system open by default
        mode="inline"
        style={{ border: "none" }}

      >

        <Menu.Item key="/home" icon={<MacCommandOutlined />}>
          <NavLink to="/home">Radar+</NavLink>
        </Menu.Item>

        <Menu.Item key="/home/market-trends" icon={<ShoppingOutlined />}>
          <NavLink to="/home/market-trends">Market Trends</NavLink>
        </Menu.Item>
        <Menu.Item key="/home/business-trends" icon={<AlertOutlined />}>
          <NavLink to="/home/business-trends">Business Trends</NavLink>
        </Menu.Item>

        {/* </SubMenu> */}
        <SubMenu key="tools_sub" icon={<ToolOutlined />} title="Tools">
          <Menu.Item
            key="/home/objective-analysis"
            icon={<ApartmentOutlined />}
          >
            <NavLink to="/home/objective-analysis">Objective Guidance</NavLink>
          </Menu.Item>
          <Menu.Item
            key="/home/decision-comparison"
            icon={<ClusterOutlined />}
          >
            <NavLink to="/home/decision-comparison">Decision Comparison</NavLink>
          </Menu.Item>
          <Menu.Item key="/home/collaboration" icon={<UsergroupAddOutlined />}>
            <NavLink to="/home/collaboration">Collaboration</NavLink>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="/home/integrations" icon={<LinkOutlined />}>
          <NavLink to="/home/integrations">Integrations</NavLink>
        </Menu.Item>

        <Menu.Item key="/business-tool-marketplace" icon={<ShoppingOutlined />}>
          <NavLink to="/business-tool-marketplace">Marketplace</NavLink>
        </Menu.Item>

      </Menu>
    </Sider>
  );
};

export default Sidebar;
